import { render, staticRenderFns } from "./FootNav.vue?vue&type=template&id=eded46e4&scoped=true&"
import script from "./FootNav.vue?vue&type=script&lang=js&"
export * from "./FootNav.vue?vue&type=script&lang=js&"
import style0 from "./FootNav.vue?vue&type=style&index=0&id=eded46e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eded46e4",
  null
  
)

export default component.exports